/* eslint-disable */
import React, { useEffect, useState, useCallback, useContext, useMemo } from "react";
import "./benefitCardv2.css";
import { BenefitGrid } from "../../../types/enrollmentV2.types";
import TotalPremium from "./totalPremiumV2/TotalPremiumV2";
import { AuthContext, GroupOwnerContext } from "../../../contexts";
import { GetBenefitsQuery } from "../../../utils/api/enrollment/enrollment";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../utils/api";
import renderCard from "./renderCardV2/RenderCardV2";
import { calculateTotalPremium } from "./helperFuntionsV2/CalculateTotalPremium";
import { processDependents, processDependentsForVEB } from "./helperFuntionsV2/ProcessDependent";
import { processRiders } from "./helperFuntionsV2/ProcessRider";
import { GROUP_NUMBER } from "../../../constants/groupNumber/groupNumber";
import CircularLoader from "../loader/CircularLoader";
import { WHOLE_LIFE_RIDERS } from "../../../constants/wholeLifeRiders";
import { VEB_PLAN_NAMES } from "../../../constants/plan";
import { prefetchService } from "../../../utils/commonFunctions/prefetchService";
import { useGetActiveVEBPlansQuery } from "../../../features/VEBPlans/vebPlansApi";
import { Plan } from "../../../types/plan.types";
const BenefitCard = () => {
	const { member } = useContext(AuthContext);
	const { groupOwner, setGroupOwner } = useContext(GroupOwnerContext);

	const [loading, setLoading] = useState(false);

	const [totalCorePremium, setTotalCorePremium] = useState<number>(0);
	const [totalVEBPremium, setTotalVEBPremium] = useState<number>(0);

	const [coreBenefits, setCoreBenefits] = useState<BenefitGrid[]>([]);
	const [vebBenefits, setVebBenefits] = useState<BenefitGrid[]>([]);

	const [coreTrueCount, setCoreTrueCount] = useState<any>({});
	const [vebTrueCount, setVebTrueCount] = useState<any>({});
	const [coreDependents, setCoreDependents] = useState<any>({});
	const [vebDependents, setvebDependents] = useState<any>({});
	const [vebRiderCount, setVebRideCount] = useState<any>({});
	const [vebRiders, setVebRiders] = useState<any>({});

	const [coreRiderCount, setCoreRiderCount] = useState<any>({});
	const [coreRiders, setCoreRiders] = useState<any>({});

	const [corePlans, setCorePlans] = useState<any[]>([]);
	const [vebPlans, setVEBPlans] = useState<any[]>([]);

	const { currentPlans, futurePlans } = useGetActiveVEBPlansQuery(member?.group_number, {
		skip: !member?.group_number,
		refetchOnMountOrArgChange: false,
		selectFromResult: ({ data }) => ({
			currentPlans: data?.currentPlans || [],
			futurePlans: data?.futurePlans || []
		})
	});
	const getAllplans = async () => {
		if (!member) {
			return;
		}

		const promise = api.plan.getVEBPlans(member?.group_number);
		trackPromise(promise);

		const response = await promise;
		setVEBPlans(response);
		console.log("FULL RESPONSE:", response);
	};
	const getCorePlan = async () => {
		if (!member) {
			return;
		}
		const planQuery = { group_number: 220 };

		const promise = api.plan.getPlans(planQuery);
		trackPromise(promise);

		const response = await promise;
		setCorePlans(response);

		console.log("FULL RESPONSE core:", response);
	};
	// ─── Fetch corePlans ONCE ──────────────────
	useEffect(() => {
		if (!member?.group_number) return;
		getAllplans();
		getCorePlan();
		api.pages
			.getEnrollmentInitData()
			.then(({ corePlansForEmployeeClassSpecific }) => {
				setCorePlans(corePlansForEmployeeClassSpecific || []);
			})
			.catch((err) => console.error("Error fetching core plans:", err));
	}, [member?.group_number]);

	// ─── Permission — safe optional chaining, no crash ───────────────────────
	const permission = useMemo(() => {
		return (groupOwner as any)?.permissions?.find((group: any) => group.group_number === member?.group_number)
			?.permission_and_subscription?.permissions?.employer_members_menu?.self?.members_list_table
			?.member_details_view;
	}, [groupOwner, member?.group_number]);

	// ─── Main benefits fetch ───────
	const getBenefits = useCallback(async () => {
		if (!member) return;
		setLoading(true);
		try {
			const getBenefitsQuery: GetBenefitsQuery = {
				group_number: member.group_number,
				insured_SSN: member.SSN,
				member_SSN: member.SSN
			};

			let benefitsResponse: any = await prefetchService.getData("benefitsOverview");
			console.log("this is the benefitsResponse", benefitsResponse);

			if (true) {
				benefitsResponse = await trackPromise(api.enrollment.getBenefitsV2(getBenefitsQuery));
				if (benefitsResponse) {
					console.log("this is the benefitsResponse benefitsResponse ", benefitsResponse);

					await prefetchService.getData(
						"benefitsOverview",
						() => Promise.resolve(benefitsResponse),
						3 * 60 * 1000
					);
				}
			}

			if (!benefitsResponse) return;

			const coreData: BenefitGrid[] = benefitsResponse.core || [];
			const vebData: BenefitGrid[] = benefitsResponse.veb || [];
			console.log("coreData,vebData", vebData, coreData);

			// ─── Process whole life riders ────────────────────────────────────
			const baseEnrollments = vebData.filter((item: any) => item.base_plan_name === VEB_PLAN_NAMES.whole_life);

			baseEnrollments.forEach((item: any) => {
				item.enrollments.forEach((enrollment: any) => {
					if (enrollment.base_plan_name === enrollment.plan_name) {
						item.enrollments.push(
							{
								base_plan_name: item.base_plan_name,
								plan_name: WHOLE_LIFE_RIDERS.waiver_of_premium,
								plan_code: item.plan_code,
								premium_amount: enrollment.waiver_of_premium,
								total_premium: enrollment.waiver_of_premium,
								member: enrollment.member
							},
							{
								base_plan_name: item.base_plan_name,
								plan_name: WHOLE_LIFE_RIDERS.accidental_death_chronic_illness,
								plan_code: item.plan_code,
								premium_amount: enrollment.accidental_death_chronic_illness,
								total_premium: enrollment.accidental_death_chronic_illness,
								member: enrollment.member
							}
						);
					}
				});
			});

			// ─── Process dependents & riders ──────────────────────────────────
			const { trueCountTemp: coreTrueCountTemp, dependentsTemp: coreDependentsTemp } =
				processDependents(coreData);
			const { trueCountTemp: vebTrueCountTemp, dependentsTemp: vebDependentsTemp } =
				processDependentsForVEB(vebData);
			const vebRidersAndCount = processRiders(vebData);
			const coreRidersAndCount = processRiders(coreData);

			// ─── Batch state updates ──────────────────────
			setCoreBenefits(coreData);
			setVebBenefits(vebData);
			setTotalCorePremium(calculateTotalPremium(coreData));
			setTotalVEBPremium(calculateTotalPremium(vebData));
			setCoreTrueCount(coreTrueCountTemp);
			setVebTrueCount(vebTrueCountTemp);
			setCoreDependents(coreDependentsTemp);
			setvebDependents(vebDependentsTemp);
			setVebRideCount(vebRidersAndCount.trueRiderTemp);
			setVebRiders(vebRidersAndCount.riderTemp);
			setCoreRiderCount(coreRidersAndCount.trueRiderTemp);
			setCoreRiders(coreRidersAndCount.riderTemp);
		} catch (error) {
			console.error("Error fetching benefits:", error);
		} finally {
			setLoading(false);
		}
	}, [member]);

	useEffect(() => {
		getBenefits();
	}, [getBenefits]);

	// ─── Shared props — built once, passed to every card ────────────

	const sharedCardProps = useMemo(
		() => ({
			coreBenefits,
			vebBenefits,
			coreTrueCount,
			vebTrueCount,
			coreDependents,
			vebDependents,
			vebRiderCount,
			vebRiders,
			corePlans,
			vebPlans,
			futurePlans,
			coreRiderCount,
			coreRiders
		}),
		[
			coreBenefits,
			vebBenefits,
			coreTrueCount,
			vebTrueCount,
			coreDependents,
			vebDependents,
			vebRiderCount,
			vebRiders,
			corePlans,
			vebPlans,
			futurePlans,
			coreRiderCount,
			coreRiders
		]
	);

	// ─── Core plans section — fix deps, use sharedCardProps instead of individual vars ──
	const renderCorePlans = useMemo(
		() => (
			<>
				<div className="plan-title-ammount">
					<div>
						<h1 className="plan-title">Core Plans</h1>
					</div>
					<div>
						<h1 className="core-total-gradient-text">
							${totalCorePremium ? totalCorePremium.toFixed(2) : ""}
						</h1>
					</div>
				</div>
				{sharedCardProps.coreBenefits.map((data: BenefitGrid, index) =>
					renderCard(
						data,
						index,
						false,
						sharedCardProps.coreBenefits,
						sharedCardProps.vebBenefits,
						sharedCardProps.corePlans,
						sharedCardProps.vebPlans,
						sharedCardProps.futurePlans,
						sharedCardProps.coreTrueCount,
						sharedCardProps.vebTrueCount,
						sharedCardProps.coreDependents,
						sharedCardProps.vebDependents,
						sharedCardProps.coreRiderCount,
						sharedCardProps.coreRiders
					)
				)}
			</>
		),
		[totalCorePremium, sharedCardProps]
	);

	//  VEB plans section — fix deps, use sharedCardProps instead of individual vars ──
	const renderVEBPlans = useMemo(
		() => (
			<>
				<div className="plan-title-ammount">
					<div>
						<h1
							className="plan-title-veb"
							style={{
								background: "linear-gradient(to right, #8a2be2, #d8bfd8)",
								WebkitBackgroundClip: "text",
								color: "transparent"
							}}
						>
							VEB Plans
						</h1>
					</div>
					<div>
						<h1 className="veb-total-gradient-text">
							${totalVEBPremium ? totalVEBPremium.toFixed(2) : ""}
						</h1>
					</div>
				</div>
				{sharedCardProps.vebBenefits.map((data: BenefitGrid, index) =>
					renderCard(
						data,
						index,
						true,
						sharedCardProps.coreBenefits,
						sharedCardProps.vebBenefits,
						sharedCardProps.corePlans,
						sharedCardProps.vebPlans,
						sharedCardProps.futurePlans,
						sharedCardProps.coreTrueCount,
						sharedCardProps.vebTrueCount,
						sharedCardProps.coreDependents,
						sharedCardProps.vebDependents,
						sharedCardProps.vebRiderCount,
						sharedCardProps.vebRiders
					)
				)}
			</>
		),
		[totalVEBPremium, sharedCardProps] // also for this only this two needed clean deps
	);

	return (
		<>
			<div className="benefits-main-container">
				{loading && <CircularLoader />}
				<TotalPremium coreTotalPremium={totalCorePremium} vebTotalPremium={totalVEBPremium} />
				{(!permission || permission.core_benefits_tab?.view) && renderCorePlans}
				{(!permission || permission.veb_benefits_tab?.view) && renderVEBPlans}
			</div>
		</>
	);
};

export default BenefitCard;
